<div class="layout-main">
  <div class="container-fluid">
    <div class="row">
      <div class="pb-2 mb-3 border-bottom col-12">
        <h2>
          <b>Announcement Log</b>
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true">
          <ng-template pTemplate="header">
            <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
          </ng-template>
          <div class="row">
            <div class="col-4">
              <p-floatLabel>
                <input [(ngModel)]="announcementPreFilterCriteria.subject" class="form-control" id="subject"
                       pInputText type="text"/>
                <label>Subject</label>
              </p-floatLabel>
            </div>
            <div class="col-4">
              <p-floatLabel>
                <input [(ngModel)]="announcementPreFilterCriteria.fromMail" class="form-control"
                       pInputText type="text">
                <label>From Address</label>
              </p-floatLabel>
            </div>
            <div *ngIf="permission" class="col-4">
              <p-floatLabel>
                <p-dropdown [(ngModel)]="announcementPreFilterCriteria.user" [options]="usersItems" [filter]="true" [loading]="loadingListUsers" showClear="true">
                </p-dropdown>
                <label>User</label>
              </p-floatLabel>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <p-floatLabel>
                <input [(ngModel)]="announcementPreFilterCriteria.message" class="form-control"
                       id="message"
                       pInputText type="text">
                <label>Body message</label>
              </p-floatLabel>
            </div>
            <div class="col-2">
              <p-floatLabel>
                <p-calendar [(ngModel)]="announcementPreFilterCriteria.sentDateFrom"
                            [showIcon]="true" dataType="string" dateFormat="mm/dd/yy">
                </p-calendar>
                <label>From</label>
              </p-floatLabel>
            </div>
            <div class="col-2">
              <p-floatLabel>
                <label>To</label>
                <p-calendar [(ngModel)]="announcementPreFilterCriteria.sentDateTo"
                            [showIcon]="true" dataType="string" dateFormat="mm/dd/yy">
                </p-calendar>
                <label>To</label>
              </p-floatLabel>
            </div>
            <div class="col-4 p-float-label">
              <div class="row">
                <div class="ml-auto mt-auto buttons-margin-left">
                  <div class="d-flex mt-2">
                    <div class="mr-2">
                      <button (click)="search()" icon="fa fa-search pr-2" iconPos="left" label="Search" pButton
                              style="margin-right: 10px" type="button"></button>
                      <button (click)="reset()" icon="fa fa-refresh pr-2" iconPos="left" label="Reset" pButton
                              type="button"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <p-table (onLazyLoad)="loadLazy($event)" [lazy]="true" [paginator]="true" [rows]="rows"
                 [totalRecords]="size" [value]="announcementList" class="text-table">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let col of cols" [style.width]="col.width">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template let-announcement pTemplate="body">
            <tr>
              <td>{{ announcement.sentAt | date:'MMM d, y H:mm' }}</td>
              <td *ngIf="announcement.announcementSentMessage[0]?.fromMail"
                  style="word-wrap: break-word; max-width: 59%;">
                <button (click)="openMessage(announcement)" class="btn btn-link" name="name_link"
                        style="font-size: 13px; text-align: left; max-width: 100%"
                        type="button">{{ announcement.subject }}
                </button>
              </td>
              <td *ngIf="!announcement.announcementSentMessage[0]?.fromMail"
                  style="word-wrap: break-word; max-width: 59%;">{{ announcement.subject }}
              </td>
              <td *ngIf="permission">{{ announcement.createdByUser?.name }}</td>
              <td>{{ announcement.announcementSentMessage[0]?.fromMail }}</td>
              <td *ngIf="permission">
                <button *ngIf="announcement.announcementSentMessage[0]" icon="fa fa-bars" pButton routerLink="/{{announcement.id}}/listRecipients"
                        style="margin:auto; display:block;"
                        type="button"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            {{ size }} results
          </ng-template>
        </p-table>
      </div>
    </div>
    <p-dialog [(visible)]="display" dismissableMask="true" header="{{title}}" modal="true">
      <div *ngIf="announcement">
        <div class="form-group" style="text-align: center;">
          <img alt="" src="{{srcImg}}">
        </div>
        <div [innerHTML]="announcement.announcementSentMessage[0]?.message" style="font-size: 12px"></div>
        <p style="color: grey; font-size: 12px">
          This is an automated message. Please do not reply to this message.<br>
          contact <a href="mailto:{{urgentEmailAddress}}">{{ urgentEmailAddress }}</a> for urgent
          production
          issues that are not weather-related. <br>
          contact <a href="mailto:{{supportEmailAddress}}">{{ supportEmailAddress }}</a> for all other
          non-urgent and weather-related issues. <br>
          contact <a href="mailto:{{onboardingEmailAddress}}">{{ onboardingEmailAddress }}</a> for
          client-related matters.<br>
        </p>
        <div *ngIf="permission">
          <h6>List of recipient companies getting McKay banner:</h6>
          <ul *ngFor="let company of announcement.company">
            <li>
              <span>{{ company.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </p-dialog>
  </div>
</div>


